<template>
  <div id="app" style="padding-bottom: 100px" v-if="!$LoadFromDomain">
    <transition name="van-fade" mode="out-in">
      <router-view
        @openDownload="downloadState = true"
        :copyright="copyright"
      />
    </transition>
    <div style="width: 100%"></div>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="wap-home" to="/">{{$t("app.common.home")}}</van-tabbar-item>
      <van-tabbar-item
        icon="chat-o"
        @click="openChat"
        :badge="unread == 0 || $store.state.wonder_chat_token === null ? '' : unread"
        >{{$t("app.common.chat")}}</van-tabbar-item
      >

      <van-tabbar-item icon="chart-trending-o" to="/quotes"
        >{{$t("app.common.stock")}}</van-tabbar-item
      >
      <van-tabbar-item icon="cash-on-deliver" to="/create_capital_accounts"
        >{{$t("app.common.trade")}}</van-tabbar-item
      >
      <!-- <van-tabbar-item icon="setting-o"  @click="downloadState = true">APP下载</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="service-o"  @click="openChat">联系客服</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="user-o" @click="openMember">账户</van-tabbar-item> -->
      <van-tabbar-item icon="user-o" to="/member">{{$t("app.common.account")}}</van-tabbar-item>
    </van-tabbar>
    <!-- ================================ DOWNLOAD POPUP ============================================== -->
    <van-popup v-model="downloadState" :style="{ width: '70%' }">
      <!-- <div class="download">
        <van-row>
          <van-col span="24">
            <h4 class="downloadTitle">请下载交易APP进行操作</h4>
          </van-col>
        </van-row>
        <van-row style="padding: 0 10px; text-align: center">
          <van-col span="12"> -->
            <!-- ios -->
            <!-- <van-button
              type="danger"
              size="large"
              @click="downloadTf"
              style="width: 90%"
              >苹果防闪退版
            </van-button>
          </van-col>
          <van-col span="12"> -->
            <!-- android -->
            <!-- <van-button
              type="danger"
              size="large"
              @click="downloadAndroidPro"
              style="width: 90%"
              >安卓专业版
            </van-button>
          </van-col>
        </van-row>
        <van-divider /> -->
        <!-- second line -->
        <!-- <van-row style="padding: 0 10px; text-align: center">
          <van-col span="12"> -->
            <!-- ios -->
            <!-- <van-button
              type="danger"
              size="large"
              @click="downloadAppleFree"
              style="width: 90%"
              >苹果免升级版
            </van-button>
          </van-col>
          <van-col span="12"> -->
            <!-- android -->
            <!-- <van-button
              type="danger"
              size="large"
              @click="downloadAndroidFree"
              style="width: 90%"
              >安卓免升级版
            </van-button>
          </van-col>
        </van-row>
        <van-divider /> -->
        <!-- third line -->
        <!-- <van-row style="padding: 0 10px; text-align: center">
          <van-col span="12"> -->
            <!-- ios -->
            <!-- <van-button
              type="danger"
              size="large"
              @click="download"
              style="width: 90%"
              >苹果经典版
            </van-button>
          </van-col>
          <van-col span="12"> -->
            <!-- android -->
            <!-- <van-button
              type="danger"
              size="large"
              @click="download"
              style="width: 90%"
              >安卓经典版
            </van-button>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <h4 class="downloadTitle">专业加密 安全无忧</h4>
          </van-col>
        </van-row> -->
      <!-- </div> -->

        <div class="contentBg" v-bind:style="appDownloadImg != '' ? 'background: url('+appDownloadImg+') no-repeat;': ''">
          <div class="progress">


              <van-row type="flex" justify="center">
                <van-col span="10"> <img  @click="showPopup('vueandrod')" :src=vueandroid_btn_app width="90%"> </van-col>
                <van-col span="10"> <img  @click="showPopup('nativeapp_ios')" :src=nativeapp_ios_btn_app width="90%"> </van-col>
              </van-row>

              <!-- <van-row type="flex" justify="center">
                <van-col span="10"> <img @click="showPopup('dnzqandroid')" :src=android_btn_app width="90%"> </van-col>
                <van-col span="10"> <img @click="showPopup('dnzqapple')" :src=apple_btn_app width="90%"> </van-col>
              </van-row> -->



              <!-- <van-row type="flex" justify="center"> -->
                <!-- <van-col span="10"> <img @click="showPopup('mac')" src="./assets/images/AMac.png" width="90%"> </van-col> -->
                <!-- <van-col span="10"> <img @click="showPopup('testflight')" src="./assets/images/A-TFapple.png" width="90%"> </van-col> -->
              <!-- </van-row> -->



              <van-row type="flex" justify="center">
                <!-- <van-col span="10"> <img @click="showPopup('windows')" src="./assets/images/Awindows.png" width="90%"> </van-col> -->
                <!-- <van-col span="10"> <img @click="showPopup('vueWindows')" :src=windows_btn_app width="90%"> </van-col> -->
                <!-- <van-col span="10"> <img @click="showPopup('testflight')" :src=testflight_btn_app width="90%"> </van-col> -->
                
              </van-row>

              <!-- <van-row type="flex" justify="center">
                <van-col span="10"> <img @click="showPopup('dnzqappletf')" :src=dnzqappletf_app width="90%"> </van-col>
              </van-row> -->
          </div>
        </div>







    </van-popup>
  </div>
</template>

<script>
import { SplashScreen } from "@capacitor/splash-screen";
import { Browser } from "@capacitor/browser";
import CimSdk from "./assets/cim/cim.web.sdk";
import "./assets/cim/message";
import "./assets/cim/replybody";
import "./assets/cim/sentbody";
import $ from "jquery";
import eventBus from "./assets/js/eventBus";
import md5 from "md5";
import { Capacitor } from "@capacitor/core";
import { version } from "../package";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "App",
  components: {},
  data() {
    return {
      senderNameInReceving: "",
      active: null,
      downloadState: false,
      copyright: "",
      // codes: [],
      androidProLink: "",
      appleFreeUpgrade: "",
      androidFreeUpgrade: "",
      commonDownload: "",
      testFlightLink: "",
      qserver_url: "",
      dnzq_android: "",
      dnzq_apple: "",
      dnzq_apple_tf: "",
      appDownloadImg: "",
      pc_windows: "",
      vueandroid_btn_app: "",
      nativeapp_ios_btn_app : "",
      testflight_btn_app: "",
      windows_btn_app:"",
      apple_btn_app:"",
      android_btn_app:"",
    };
  },
  computed: {
    unread: function (val) {
      var c = 0;
      this.$store.state.message_list.forEach((element) => {
        c += element.unread;
      });
      c += this.$store.state.system_message_unread;
      return c;
    },
  },
  methods: {

    showPopup(operate) {
          switch (operate) {
            case "testflight":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_testflight');
              window.open(this.testFlightDownload)
              break;
            case "vueandrod":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_vueandrod');
              window.open(this.androidPro)
              break;
            case "applefree":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_applefree');
              window.open(this.appleFreeUpgrade)
              break;
            case "androidfree":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_androidfree');
              window.open(this.androidFreeUpgrade)
              break;
            case "nativeapp_android":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_nativeapp_android');
              window.open(this.nativeApp)
              break;
            case "nativeapp_ios":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_nativeapp_ios');
              window.open(this.nativeApp)
              break;
            case "dnzqandroid":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_dnzqandroid');
              window.open(this.dnzq_android)
              break;
            case "dnzqapple":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_dnzqapple');
              window.open(this.dnzq_apple)
              break;
            case "dnzqappletf":
              this.qrPopup = true;
              this.popupContent = this.$t('app.download.popup_dnzqappletf');
              window.open(this.dnzq_apple_tf)
              break;
            case "mac":
              this.qrPopup = false;
              this.popupContent = this.$t('app.download.popup_mac');
              window.open(this.pc_mac)
              break;
            case "windows":
              this.qrPopup = false;
              this.popupContent = this.$t('app.download.popup_windows');
              window.open(this.pc_windows)
              break;
            case "vueWindows":
              this.qrPopup = false;
              this.popupContent = "";
              window.open(this.pc_windows)
              break;

            default:
              break;
          }
        },



    nav() {
      let that = this;

      var url = window.location.href;

      if (
        url.includes("members") ||
        url.includes("login") ||
        url.includes("registered")
      ) {
        that.active = 4;
      } else if (url.includes("service_chat") || url.includes("service")) {
        that.active = 1;
      } else if (url.includes("home")) {
        that.active = 0;
      }
    },
    openChat() {
      let that = this;
      if (
        that.$store.state.loginType &&
        that.$store.state.wonder_chat_token !== null
      ) {
        that.$router.push({ name: "ChatRoom" });
      } else if (
        that.$store.state.loginType &&
        that.$store.state.wonder_chat_token === null
      ) {
        if (Capacitor.getPlatform() === "android") {
          //check if android app, if android app use native plugin to open popup
          Browser.open({ url: this.qserver_url });
        } else {
          window.open(this.qserver_url);
        }
      } else {
        that.$router.push("/login");
      }
    },
    // openMember(){
    //   let that = this;
    //   if (that.$store.state.loginType){
    //     that.$router.push('/member')
    //   }else{
    //     that.$router.push('/login')
    //   }
    // },
    // download() {
    //   window.location.href = this.codes[0].code;
    // },
    downloadTf() {
      window.location.href = this.testFlightLink;
    },
    downloadAndroidPro() {
      window.location.href = this.androidProLink;
    },
    downloadAppleFree() {
      window.location.href = this.appleFreeUpgrade;
    },
    downloadAndroidFree() {
      window.location.href = this.androidFreeUpgrade;
    },
    download() {
      window.location.href = this.commonDownload;
    },
    web_common() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "web_common",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            // that.codes = resData.data.codes;
            that.copyright = resData.data.copyright;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(that.$t(resData.msg));
          }
        });
    },
    getAppDownloadLinks() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "download_link",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.testFlightDownload = res.data.data.iOS_testflight;
            that.androidPro = res.data.data.android_pro;
            that.appleFreeUpgrade = res.data.data.apple_free_upgrade;
            that.androidFreeUpgrade = res.data.data.android_free_upgrade;
            that.nativeApp = res.data.data.app_app;

            that.dnzq_android = res.data.data.dnzq_android;
            that.dnzq_apple = res.data.data.dnzq_apple;
            that.dnzq_apple_tf = res.data.data.dnzq_apple_tf;
            that.appDownloadImg = res.data.data.app_download_image;
            that.pc_windows = res.data.data.window_free_upgrade;

            //buttons from config
            that.vueandroid_btn_app = res.data.data.vueandroid_btn_app;
            that.nativeapp_ios_btn_app = res.data.data.nativeapp_ios_btn_app;
            that.testflight_btn_app = res.data.data.testflight_btn_app;
            that.windows_btn_app = res.data.data.windows_btn_app;
            that.apple_btn_app = res.data.data.apple_btn_app;
            that.android_btn_app = res.data.data.android_btn_app;

          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(that.$t(resData.msg));
          }
        });
    },
    getDomainLink() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            name: "domain_url",
          },
        })
        .then(function (res) {
          if (res.data.code === 1) {
            window.open(res.data.data, "_blank");
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.startLocalSource();
          }
        })
        .catch(function (e) {
          that.startLocalSource();
        })
        .finally(function () {
          // window.open("https://www.google.com","blank");
          // setTimeout(() => {
          //   SplashScreen.hide();
          // }, 3000);
          SplashScreen.hide();
        });
    },
    startLocalSource() {
      this.getKey();
      this.web_common();
      this.nav();
      this.getAppDownloadLinks();
      SplashScreen.hide();
      $(".loader").hide();
    },
    getKey() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "home",
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            localStorage.setItem(
              "encript_public_key",
              resData.data.encript_public_key
            );
          }
        });
    },

    /**
     * wonder chat system
     */
    startChatSystem() {
      this.onChatLogin();
    },
    onChatLogin() {
      let that = this;
      that
        .$wonderChat({
          url: "api/user/login",
          method: "post",
          data: {
            account: localStorage.getItem("user_number"),
            password: md5(localStorage.getItem("password")),
          },
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            if (localStorage.account !== localStorage.user_number) {
              that.$store.commit("clearMessageCache");
              that.$store.commit("clearChannelMessageCache");
            }
            that.$store.commit("setWonderChatLoginAccount", data.data);
            that.$store.commit("setWonderChatToken", data.token);
            that.$store.commit("clearOlderMessages");
            that.$store.commit("clearChannelOlderMessages");
            CimSdk.connect(this);
            if (that.$store.state.message_list.length == 0) {
              that.getChatMain();
            }
            if (that.$store.state.channel_list.length == 0) {
              that.loadAllChannel();
            }
          } else {
            that.showError = true;
            that.errorText = "invalid login";
          }
        });
    },
    //============================== load all channel list ================
    loadAllChannel() {
      let that = this;
      that
        .$wonderChat({
          url: "api/group/list?type=1",
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          if (res.data.code == 200) {
            // that.allChannelList = res.data.dataList;
            that.$store.commit("updateChannelList", res.data.dataList);
          }
        });
    },
    /**
     * no implementaion yet
     */
    onReplyReceived(reply) {
      localStorage.setItem("lastHeartBeat", reply.timestamp);
      if (reply.key === "client_bind") {
        if (reply.code === "200") {
          CimSdk.startHeartBeat();
        }
      } else if (reply.key === "heartbeat") {
        //here comes heartbeat
      }
    },
    /**
     * this method gets invoked when new message comes from socket
     * and this will pass that information to the store
     */
    onMessageReceived(message) {
      this.setSenderName(message, message.extra);
    },
    setNameofSender(message) {
      if (this.senderNameInReceving) {
        message["sendername"] = this.senderNameInReceving;
      }
      this.$store.commit("setMessage", {
        message: message,
        caller: this,
        sentMessage: false,
      });
      //check if sender chat is open
      if (this.$route.name === "ChatRoomUser") {
        if (this.$route.params.account === message.sender) {
          eventBus.$emit("readMessage");
        }
      }
      //chennel if sender chat is open
      if (this.$route.name === "ChannelRoomUser") {
        if (this.$route.params.account == message.sender) {
          eventBus.$emit("readMessage");
        }
      }
      this.receiveRequest(message.id);
      console.log(message.action);
      if (message.action == 3) {
        this.voiceChannel();
      } else {
        this.voice();
      }
      // $(".chatWindowBody").animate(
      //   { scrollTop: $(".chatWindowBodyUl").height() },
      //   "fast"
      // );
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(resData.msg));
          }
        });
    },
    getUserInfo(account) {
      // console.log('get user info',user);
      let that = this;
      that
        .$wonderChat({
          url: "api/user/userdetails/" + account,
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            that.$store.commit("updateUser", data.data);
          }
        });
    },
    getChatMain() {
      // var that = this;
      // that
      //   .$wonderChat({
      //     url: "/web/main?account=" + localStorage.getItem("user_number"),
      //     method: "get",
      //     headers: {
      //       "access-token": that.$store.state.wonder_chat_token,
      //     },
      //   })
      //   .then(function (res) {
      //     console.log(res);
      //     let resData = res.data;
      //     // that.friendArrList = resData.data.onlineFriendList[0].list;
      //     console.log(resData.data.onlineFriendList[0].list);
      //     // that.$store.commit("setAgentList",resData.data.onlineFriendList[0].list);
      //   })
      let that = this;
      that
        .$wonderChat({
          url: "/web/main?account=" + localStorage.getItem("user_number"),
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          let data = res.data;
          let resData = res.data;
          // console.log(resData.data.onlineFriendList[0].list);
          that.$store.commit(
            "setAgentList",
            resData.data.onlineFriendList[0].list
          );
        });
    },
    receiveRequest(id) {
      let that = this;
      that
        .$wonderChat({
          url: "/api/message/received/" + id,
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {});
    },
    voice() {
      if (!this.$store.state.wonder_chat_notice_sound) return;
      var audio = document.createElement("audio");
      audio.src =
        process.env.WONDER_CHAT_ROOT +
        "/resource/layim/css/modules/layim/voice/default.mp3";
      audio.play();
    },
    voiceChannel() {
      if (!this.$store.state.wonder_channel_notice_sound) return;
      var audio = document.createElement("audio");
      audio.src =
        process.env.WONDER_CHAT_ROOT +
        "/resource/layim/css/modules/layim/voice/default.mp3";
      audio.play();
    },
    setSenderName(message, account) {
      let that = this;
      that
        .$wonderChat({
          url: "api/user/getUserUpdated?account=" + account,
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            if (account) {
              that.senderNameInReceving = data.data[account].username;
            }
            that.setNameofSender(message);
          }
        });
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    doLogin(userPhone, password) {
      let that = this;
      const toast = that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: this.$t('app.common.loading'),
      });
      let publicKey = localStorage.getItem("encript_public_key");
      let phoneNumber = that.encryptMessage(userPhone, publicKey);
      let userPasword = that.encryptMessage(password, publicKey);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "login_e",
            phone: phoneNumber,
            password: userPasword,
            app_version: version,
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code === 1) {
            toast.clear();
            window.sessionStorage.setItem("loginType", true);
            window.sessionStorage.setItem("token", resData.data.token);
            that.$store.commit("changeLoginType", true);
            that.$store.commit("changePhone", that.phone);
            let user_number = resData.data.user_number;
            localStorage.setItem("user_number", user_number);
            that.startChatSystem();
          } else if (resData.code === 0) {
            toast.clear();
            that.$router.push("/login");
          }
        })
        .catch(() => {
          toast.clear();
        });
    },
  },
  mounted: function () {
    // SplashScreen.show({
    //   // autoHide: false,
    // });
    this.get_qchat_server_url();
    if (this.$LoadFromDomain) {
      this.getDomainLink();
    } else {
      this.startLocalSource();
    }
    // if (this.$store.state.loginType) {
    //   this.startChatSystem();
    // }
    if (process.env.AUTO_LOGIN && window.localStorage.getItem("al")) {
      let al = window.localStorage.getItem("al");
      let data = JSON.parse(atob(al));
      this.doLogin(data.u, data.p);
    } else {
      if (this.$store.state.loginType) {
        this.startChatSystem();
      }
    }
  },
  updated: function () {
    this.nav();
  },
  created() {
    eventBus.$on("startChat", (data) => {
      this.startChatSystem();
    });
  },
};
</script>

<style>
#app {
}
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom)-10px;
  padding-bottom: env(safe-area-inset-bottom)-10px;
}
.downloadTitle {
  text-align: center;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  text-align: center;
}

.contentBg {
  background: url("./assets/images/bg.png");
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  /* padding: 500px 15px 40px; */
}

.progress {
  text-align: center;
  padding: 200px 0px 150px 0px;  /* SET TOP AND BOTTOM  */
}
</style>



// WEBPACK FOOTER //
// src/App.vue